'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.postAndRetry = postAndRetry;

var _xr = require('xr');

var _xr2 = _interopRequireDefault(_xr);

var _uuid = require('uuid');

var _uuid2 = _interopRequireDefault(_uuid);

var _storage = require('./storage');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var storage = new _storage.Storage('postAndRetry', false);

function _postAndRetry(url, data, interval, reqId) {
  var promise = _xr2.default.post(url, data);
  promise.then(function (resp) {
    if (reqId != null) {
      var retryEntries = storage.getKey('retryEntries');
      delete retryEntries[reqId];
      storage.setKey('retryEntries', retryEntries);
    }
  }).catch(function (err) {
    var requestId = reqId == null ? _uuid2.default.v4() : reqId;
    var retryEntries = storage.getKey('retryEntries') || {};
    retryEntries[requestId] = { url: url, data: data, interval: interval };
    storage.setKey('retryEntries', retryEntries);
    setTimeout(function () {
      return retry(reqId);
    }, interval);
  });
  return promise;
}

function retry(reqId) {
  var retryEntries = storage.getKey('retryEntries') || {},
      entry = retryEntries[reqId];
  console.log('retry', reqId, entry);
  if (entry != null) {
    var url = entry.url,
        data = entry.data,
        interval = entry.interval;

    _postAndRetry(url, data, interval, reqId);
  }
}

function retryAll() {
  var retryEntries = storage.getKey('retryEntries') || {};
  Object.keys(retryEntries).map(retry);
}

function postAndRetry(url, data) {
  var interval = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 30000;

  return _postAndRetry(url, data, interval);
}

retryAll();


//////////////////
// WEBPACK FOOTER
// ./~/dooh-utils/dist/postAndRetry.js
// module id = 66
// module chunks = 0